import { useCatalog } from '@/common/use/useCatalog'
import { getExecuteUrl } from '@/common/converter/utils/get-execute-url'
const { contextList, getCatalog, addContextProperty, addEventList } =
  useCatalog()

/**
 * context 에 contextProperty, Index, EventList 를 추가하여 반환한다.
 * @param elementList
 * @returns {Promise<[]>}
 */
export const getCombinedContextList = async (elementList = []) => {
  await getCatalog(getExecuteUrl(elementList))
  addContextProperty(elementList)
  addEventList(elementList)

  return contextList.value
}
